// @flow

import { createSelector } from 'reselect';

import {
  selectCurrency as selectPrepaidCurrency,
  selectAvailableCurrencies as selectBUCurrencies,
} from '@gandi/billing';
import type { Currency } from '@gandi/billing';

import { selectCurrencies } from '@gandi/redux-places';

import type { FullState } from 'src/types';

const EMPTY_ARRAY: Array<string> = [];

type SelectShopCurrenciesArgs = { sharingId?: string, country?: string };
export const selectShopCurrencies: (
  state: FullState,
  args: SelectShopCurrenciesArgs,
) => Array<string> | Array<Currency> = createSelector(
  [
    state => state,
    (state, args) => args.sharingId,
    (state, { country }: SelectShopCurrenciesArgs) => country,
  ],
  (state, sharingId, country) => {
    if (sharingId) {
      // use the prepaid if set
      // usual authenticated users
      const prepaidCurrency = selectPrepaidCurrency(state, { sharingId });
      if (prepaidCurrency) {
        return [prepaidCurrency];
      }

      // fallback on all BU currencies
      // if the orga never did a payment before
      const BUCurrencies = selectBUCurrencies(state, { sharingId, country });
      if (BUCurrencies && BUCurrencies.length > 0) {
        return BUCurrencies;
      }
    }

    // fallback to geo guess currencies
    // anonymous users are in this case

    // todo make this selectCurrencies return Array<Currency>
    const countryCurrencies = selectCurrencies(state, country);
    return countryCurrencies || EMPTY_ARRAY;
  },
);
